export const scrollIntoView = () => {
    const clickEventHandler = function (e) {
        e.preventDefault();
        const options = {
            behavior: this.dataset.behavior || "smooth",
            block: this.dataset.block || "start",
            inline: this.dataset.inline || "nearest"
        }
        document.querySelector(this.dataset.scrollto).scrollIntoView(options);

        if (this.dataset.hasOwnProperty('tab')) {
            document.querySelector(this.dataset.tab).dispatchEvent(new Event("click"));
        }

        return false;
    }

    document.querySelectorAll('a[data-scrollTo], button[data-scrollTo]').forEach((link) => {
        link.addEventListener('click', clickEventHandler);
    })
}